import { lightTheme } from "./lightTheme";
import { darkTheme } from "./darkTheme";

export const themeMap = {
  lightTheme,
  darkTheme,
} as const;

export type AppTheme = (typeof themeMap)[keyof typeof themeMap];
export type ThemeMapType = typeof themeMap;

export { lightTheme, darkTheme };
